import { route } from 'quasar/wrappers'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteLocationNormalized,
  NavigationGuardNext,
} from 'vue-router'
import { StateInterface } from '../store'
import routes from './routes'
import { getWorkspaceConfig } from 'src/apis/config'
import { appConnect } from 'src/system/app-connect'
import { appTheme } from 'src/system/app-config'
import { LoginResult } from 'src/system/models'
import { loginWithCustomMethod } from 'src/apis/auth/methods'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route<StateInterface>(function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  })

  const endpoint =
    process.env.NODE_ENV === 'development'
      ? '/api'
      : process.env.PRIVAGE_API_URL

  // Login middle ware
  const loginMiddleWare = (
    to: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    if (
      to.path === '/myprofile' ||
      to.path === '/member' ||
      to.path == '/wallet'
    ) {
      if (store.state.auth.accessToken !== null) {
        next()
      } else {
        appConnect.loginIfNeed(to.path, (result: LoginResult) => {
          if (result === 'login') {
            Router.replace('/login')
          } else if (result === 'next') {
            next()
          } else {
            const params = appConnect.getLoginParam(result)
            // Try login
            loginWithCustomMethod(result, params)
              .then((data) => {
                store.dispatch('auth/loginComplete', data)
                Router.replace(to.path)
              })
              .catch(() => {
                // If cannot login redirect to register
                store.dispatch('auth/setCustomLogin', {
                  slug: result,
                  params,
                  next: to.path,
                })
                Router.replace('/login')
              })
          }
        })
      }
    } else {
      next()
    }
  }

  // Page config capture
  Router.beforeEach((to, from, next) => {
    const slug = Router.options.history.base.replace('/', '')
    if (slug && store.state.config.id === 0) {
      getWorkspaceConfig(endpoint, slug)
        .then((result) => {
          // Save to store
          store.dispatch('config/setConfig', {
            id: result.id,
            name: result.name,
            description: result.description,
            slug: result.slug,
            image: result.image,
            endpoint: endpoint,
            display_point: result.display_point
          })

          // Setup app theme
          appTheme.init(result)

          // Setup app connect
          appConnect.init(result)

          loginMiddleWare(to, next)
        })
        .catch(() => next(false))
    } else {
      next()
    }
  })

  return Router
})
